import YpRiskAssessmentForm from './YoungPersonRiskAssessment';
export default YpRiskAssessmentForm;
